<!-- Dialog: Fwd Roll Replace Portfolio being priced  -->
<p-dialog
  #dialog
  [(visible)]="data.dialogData.show"
  [width]="data.dialogData.width"
  appendTo="body"
  [resizable]="false"
  [closable]="true"
  [modal]="true"
  [draggableDialog]="dialog"
  styleClass="bfx-dialog-warning"
  (onHide)="closeDialog()"
>
  <p-header> {{ data.dialogData.title_text }} </p-header>

  <p [innerHTML]="data.dialogData.message_text"></p>

  <p-footer fxLayout="row">
    <div fxFlex="1 1">
      <button
        pButton
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="saveOperation()"
        [label]="data.dialogData.save_operation_button"
      ></button>
      <button
        pButton
        type="button"
        fxFlex="135px"
        class="bfx-button-secondary-subtle"
        (click)="abortOperation()"
        [label]="data.dialogData.abort_operation_button"
      ></button>
    </div>

    <button
      pButton
      type="button"
      fxFlex="100px"
      class="bfx-button-primary"
      (click)="cancel()"
      [label]="data.dialogData.cancel_button"
    ></button>
  </p-footer>
</p-dialog>
